import {getDocumentCategoryId, getDocumentTypeId, getModuleId, getModuleIdStrict, getRightId, getRoleId, hasAccessTo} from "@/js/user";
import {mapGetters} from "vuex";
import {config} from "@/config/config"
import {isOffline} from "@/js/utils";
import _ from "lodash";

export default {
  computed: {
    ...mapGetters({
      user: 'GET_USER',
      common: 'GET_COMMON_DATA',
      token: 'GET_TOKEN'
    })
  },
  methods: {
    userHasRole(role, user = this.user) {
      if (isOffline()) return true;
      const roleId = this.getRoleId(role)
      //console.log('role check: ', role, roleId)
      return roleId && user && user.roleId && user.roleId === roleId
    },
    userHasAccessTo(right, module, options = {}) {
      if (isOffline()) return true;

      const defaultOptions = {
        documentCategory: null,
        documentType: null,
        documentId: null,
        documentIds: null,
        organizationIds: null,
        parentDocumentId: null,
        isPrivate: false
      }

      options = {
        ...defaultOptions,
        ...options
      }

      return this.user && this.user.rights && hasAccessTo(
        this.user.rights,
        this.getRightId(right),
        {
          moduleId: this.getModuleId(module),
          documentCategoryId: this.getDocumentCategoryId(options.documentCategory),
          documentTypeId: this.getDocumentTypeId(options.documentType),
          documentId: options.documentId,
          documentIds: options.documentIds,
          organizationIds: options.organizationIds,
          parentDocumentId: options.parentDocumentId,
          isPrivate: options.isPrivate
        }
      )
    },
    getTour(moduleId) {
      if (this.common && this.common.modules && this.common.tours) {
        if (!moduleId) return null
        const module = this.common.modules.find(m => m.moduleId === moduleId);
        if (!module) return null;
        if (module.properties.tourId) return this.common.tours.find(t => t.documentId === module.properties.tourId);
      }
    },
    getModuleIdStrict(moduleName) {
      return getModuleIdStrict(moduleName, this?.common?.modules)
    },
    getModuleId(moduleName) {
      return getModuleId(moduleName, this?.common?.modules)
    },
    getRightId(rightName) {
      return getRightId(rightName, this?.common?.rightsList)
    },
    getDocumentCategoryId(category) {
      return getDocumentCategoryId(category, this?.common?.documentCategories)
    },
    getDocumentTypeId(type) {
      return getDocumentTypeId(type, this?.common?.documentTypes)
    },
    getRoleId(role) {
      return getRoleId(role, this?.common?.rolesList)
    },
    /**
     *
     * @param modules // modules tree
     * @param menuType // main or secondary
     * @returns {*[]}
     */
    getUserMenu(modules, menuType) {
      let menu = []
      if (isOffline()) return menu;
      if (Array.isArray(modules)) {
        for (let i = 0; i < modules.length; i++) {
          const item = modules[i]
          if (
            !item.isPublic &&
            item.properties &&
            item.properties.isMenuItem &&
            item.properties.menuType === menuType &&
            this.userHasAccessTo('view', item.code) &&
            (!config.APP_MODULE_TYPE || parseInt(config.APP_MODULE_TYPE) === item.moduleTypeId)
          ) {
            let menuItem = {
              ...item,
              label: item.title,
              icon: item?.properties?.icon || 'fa fa-file-o'
            }
            if (item.children && item.children.length) {
              menuItem.items = this.getUserMenu(item.children, menuType)
              // force dashboard item
              if (item.moduleId) {
                const module = this.common.modules.find(m => m.moduleId === item.moduleId);
                if (module) {
                  this.getModuleDashboard(item.moduleId).then(dashboardId => {
                    menuItem.items.unshift({
                      label: 'Dashboard',
                      icon: 'fa fa-dashboard',
                      to: `/dashboard/${module.code.toLowerCase()}/`,
                      moduleId: item.moduleId
                    });
                  }).catch(error => {
                  });
                }
              }
            } else if (!(item.properties.path && item.properties.formId) && item.properties.actionScript) {
              menuItem.command = () => {
                try {
                  eval(item.properties.actionScript)
                } catch (e) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: e,
                    life: 5000
                  });
                }
              }
            } else if (item.properties.path) {
              menuItem.to = item.properties.path
            } else if (item.properties.formId) {
              const routeIndex = this.$router.getRoutes().findIndex(r => r.path === '/page/:formId')
              if (routeIndex > -1) {
                this.$router.getRoutes()[routeIndex].meta.moduleId = item.moduleId
              }
              menuItem.to = `/page/${item.properties.formId}/${_.kebabCase(item.title)}`
            }
            menu.push(menuItem)
          }
        }
      }
      return menu
    },

    /**
     *
     * @param modules // modules tree
     * @param menuType // main or secondary
     * @returns {*[]}
     */
    getPublicMenu(modules, menuType = null) {
      let menu = []
      if (isOffline()) return menu;
      if (Array.isArray(modules)) {
        for (let i = 0; i < modules.length; i++) {
          const item = modules[i]
          if (
            item.isPublic &&
            item.properties &&
            //item.properties.isMenuItem &&
            (!menuType || item.properties.menuType === menuType) &&
            (!config.APP_MODULE_TYPE || parseInt(config.APP_MODULE_TYPE) === item.moduleTypeId)
          ) {
            let menuItem = {
              ...item,
              label: item.title,
              icon: item?.properties?.icon || 'fa fa-file-o'
            }
            if (item.children && item.children.length) {
              menuItem.items = this.getPublicMenu(item.children, menuType)
            } else if (!(item.properties.path && item.properties.formId) && item.properties.actionScript) {
              menuItem.command = () => {
                try {
                  eval(item.properties.actionScript)
                } catch (e) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: e,
                    life: 5000
                  });
                }
              }
            } else if (item.properties.path) {
              menuItem.to = item.properties.path
            } else if (item.properties.formId) {
              const routeIndex = this.$router.getRoutes().findIndex(r => r.path === '/page/:formId')
              if (routeIndex > -1) {
                this.$router.getRoutes()[routeIndex].meta.moduleId = item.moduleId
              }
              menuItem.to = `/page/${item.properties.formId}/${_.kebabCase(item.title)}`
            }
            menu.push(menuItem)
          }
        }
      }
      return menu
    },

    /**
     * Get dashboard ID by moduleId
     * @param moduleId
     * @param searchFormsWithIndexPath
     * @param modules
     * @returns {Promise<unknown>}
     */
    getModuleDashboard(moduleId, searchFormsWithIndexPath = false, modules = this.common.modules) {
      return new Promise((resolve, reject) => {
        try {
          const right = this.user?.rights?.find(r => r.dashboardTypeId && r.moduleId === moduleId);
          if (right && right.dashboardTypeId) {
            const dashboardTypeId = right.dashboardTypeId;
            const dashboardCategoryId = this.common.documentTypes.find(el => el.documentTypeId === dashboardTypeId).documentCategoryId;
            resolve(dashboardTypeId)

            /*this.$store.dispatch('getForms', {
              data: {
                documentTypeId: dashboardTypeId,
                documentCategoryId: dashboardCategoryId
              }
            }).then(response => {
              if (response && response.length) {
                resolve(response[0]?.documentType?.documentTypeId || response[0].documentId)
              } else {
                reject(false)
              }
            }).catch(error => {
              reject(error)
            })*/
          } else if (searchFormsWithIndexPath) {
            // get the module that has a form and index path
            const indexModule = modules.find(el => el.properties.path === '/' && el.properties.formId);
            if (indexModule) {
              resolve(indexModule.properties.formId);
            } else {
              reject(false)
            }
          } else {
            reject(false)
          }
        } catch (e) {
          reject(e)
        }
      });
    }
  }
}
